import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import useInView from './useInView';

const CTABanner = () => {
  const { t } = useLang();
  const [ref, inView] = useInView();

  return (
    <section
      ref={ref}
      style={{
        position: 'relative',
        padding: '100px 24px',
        overflow: 'hidden',
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(40px)',
        transition: 'all 0.8s ease',
      }}
    >
      {/* Background gradient */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(135deg, rgba(46,90,255,0.2) 0%, rgba(138,43,226,0.25) 50%, rgba(255,59,154,0.2) 100%)',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }} />

      {/* Decorative orbs */}
      {[
        { left: '-5%', top: '-50%', size: 400, color: 'rgba(46,90,255,0.15)', anim: '8s' },
        { right: '-5%', bottom: '-50%', size: 350, color: 'rgba(255,59,154,0.12)', anim: '10s' },
        { left: '40%', top: '-30%', size: 200, color: 'rgba(138,43,226,0.1)', anim: '6s' },
      ].map((orb, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            width: orb.size,
            height: orb.size,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${orb.color}, transparent 70%)`,
            left: orb.left,
            right: orb.right,
            top: orb.top,
            bottom: orb.bottom,
            animation: `float ${orb.anim} ease-in-out infinite`,
            pointerEvents: 'none',
          }}
        />
      ))}

      <div style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: '800px',
        margin: '0 auto',
        textAlign: 'center',
      }}>
        <h2 style={{
          fontSize: 'clamp(32px, 5vw, 52px)',
          fontWeight: 800,
          color: '#fff',
          marginBottom: '16px',
          letterSpacing: '-1px',
        }}>
          {t('cta_title')}
        </h2>
        <p style={{
          fontSize: '18px',
          color: 'rgba(255,255,255,0.7)',
          marginBottom: '40px',
          lineHeight: 1.7,
        }}>
          {t('cta_sub')}
        </p>
        <Link
          to="/program"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            padding: '18px 40px',
            background: 'linear-gradient(135deg, #2E5AFF, #8A2BE2, #FF3B9A)',
            backgroundSize: '200% auto',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '50px',
            fontSize: '16px',
            fontWeight: 700,
            boxShadow: '0 20px 60px rgba(46,90,255,0.4)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={e => {
            e.currentTarget.style.transform = 'translateY(-3px) scale(1.03)';
            e.currentTarget.style.boxShadow = '0 30px 80px rgba(46,90,255,0.5)';
          }}
          onMouseOut={e => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 20px 60px rgba(46,90,255,0.4)';
          }}
        >
          {t('cta_btn')}
          <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  );
};

export default CTABanner;
